import { getSupportedImageFormat } from '@/utils'

export default defineNuxtPlugin(async () => {
  try {
    await getSupportedImageFormat()
  } catch (error) {
    console.warn('[oss] failed to warm image format support cache', error)
  }
})
